













import { Component, Prop, Vue } from "vue-property-decorator";
import Tag from "@/components/Tag.vue";

@Component({
  components: {
    Tag,
  }
})
export default class Card extends Vue {
  name = "card"
  @Prop() cardTitle: string
  @Prop() cardPreview: string
  @Prop() cardTags: Array<any>
  @Prop() cardId: string
}
